import { IAppConfig } from '@rccl/telemetry-events';
import { environment } from '~env';
import { ENDPOINTS_CONFIG } from './telemetry-endpoints.config';

export class TelemetryConfig {
  private static get endpoints(): any {
    return ENDPOINTS_CONFIG.map(e => ({
      ...e,
      server: environment.mw.host,
      env: environment.telemetry.env,
    }));
  }

  public static get config(): IAppConfig {
    return {
      debug: {
        isEnabled: environment.telemetry.debug,
      },
      batch: {
        batchSize: environment.telemetry.batch.batchSize,
        isEnabled: environment.telemetry.batch.isEnabled,
      },
      appEnv: environment.telemetry.env,
      endpoints: this.endpoints,
      appId: environment.telemetry.appId,
      appVers: environment.version,
      appKey: environment.mw.appKey,
      vdsId: '',
      trackingUrl: environment.telemetry.trackingUrl,
      disableTelemetry: !environment.telemetry.enabled,
    };
  }
}
